import React from "react";

export default function PremiumGate({ onSubscribe }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 space-y-4 text-center">
      <div className="bg-gray-100 rounded-full p-4">
        <svg
          className="w-8 h-8 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
      <h3 className="text-base font-semibold text-gray-700">
        This feature requires an active subscription
      </h3>
      <p className="text-sm text-gray-500 max-w-xs">
        Your free trial has ended. Subscribe for $50/month to restore full
        access.
      </p>
      <button
        onClick={onSubscribe}
        className="bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium px-5 py-2 rounded-lg transition"
      >
        Subscribe Now
      </button>
    </div>
  );
}
